import { maxLength, requiredIf } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import * as types from '@/store/types'
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'

function phoneValidator(value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  try {
    parsePhoneNumber(value, 'RU')
    return isValidPhoneNumber(value, 'RU')
  } catch (e) {
    return false
  }
}

function emailValidator(value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^\s*?(.+)@(.+?)\s*$/.test(value)
}

function personalDataAgreementValueValidator(value, vm) {
  return vm.validPersonalDataAgreement
}

function timesValidator(value) {
  return value.length > 0
}

function requiredElement(vue, code) {
  for (const element of vue.webForm.screens[vue.page].elements) {
    if (element.code === code) {
      return true
    }
  }

  return false
}

export default {
  name: 'FormRegistratorController',
  data() {
    return {
      apiKey: null,
      phoneConfirm: false,
      disableConfirmPhone: false,
      emailConfirm: false,
      disableConfirmEmail: false,
      clientCommentAvailable: false,
      webDomain: null,
      personalDataAgreement: false,

      location: null,
      registrator: null,
      menuItem: null,
      day: null,
      queue: null,
      times: [],
      name: null,
      email: null,
      phone: null,
      comment: null,
      personalData: false,

      locations: [],
      registrators: [],
      menu: [],
      schedules: [],

      captcha: null,
      captchaUrl: '',
      captchaErrorMessage: null,
      captchaLength: 0,
      captchaValid: false,

      confirmEmail: null,
      confirmEmailErrorMessage: null,
      confirmPhone: null,
      confirmPhoneErrorMessage: null,

      scheduleErrorMessage: null,
      scheduleError: false,

      page: 0,
      maxPage: 1,
      isGenerateCode: false,
      lastEmail: null,
      lastPhone: null,
      showConfirmCodesOnLastPage: false,

      generateCodePhoneDisable: false,
      generateCodeEmailDisable: false,

      generateCodePhoneDisableTime: 0,
      generateCodeEmailDisableTime: 0,

      authInfo: null,

      webForm: null
    }
  },
  validations: {
    location: {
      required: requiredIf(vm => requiredElement(vm, 'location'))
    },
    menuItem: {
      required: requiredIf(vm => requiredElement(vm, 'menuItem'))
    },
    name: {
      required: requiredIf(vm => requiredElement(vm, 'name')),
      maxLength: maxLength(128)
    },
    email: {
      required: requiredIf(vm => requiredElement(vm, 'email')),
      maxLength: maxLength(129),
      emailValidator
    },
    phone: {
      required: requiredIf(vm => requiredElement(vm, 'phone')),
      maxLength: maxLength(18),
      phoneValidator
    },
    day: {
      required: requiredIf(vm => requiredElement(vm, 'day'))
    },
    times: {
      required: requiredIf(vm => requiredElement(vm, 'times')),
      timesValidator
    },
    captcha: {
      required: requiredIf(vm => vm.captchaLength > 0),
      maxLength: maxLength(10)
    },
    personalData: {
      personalDataAgreementValueValidator
    },
    confirmEmail: {
      required: requiredIf(vm => requiredElement(vm, 'confirmEmail'))
    },
    confirmPhone: {
      required: requiredIf(vm => requiredElement(vm, 'confirmPhone'))
    }
  },
  computed: {
    disableDate() {
      return !this.location || !this.menuItem
    },
    disableMenu() {
      return !this.location
    },
    showTimes() {
      return !this.disableDate && this.day
    },
    showConfirmPage() {
      if (this.haveConfirm && !this.showConfirmCodesOnLastPage) {
        if (this.registrator) {
          // Ввод телефона/email на том же экране, что и выбор локации, или дальше. Отображаем там, где был ввод
          return this.onThisPage('phone') || this.onThisPage('email')
        }
      }
      return this.page === this.maxPage
    },
    showPreButton() {
      // мы можем листать страницу назад, если не находимся на странице с подтверждением кодов (там кнопка отмена)
      return this.page > 0 && this.page <= this.maxPage
    },
    showNextButton() {
      return this.page < this.maxPage
    },
    validateButton() {
      return this.onThisPage('times') && (this.day && this.schedules.length === 0)
    },
    showSaveButton() {
      return this.page === this.maxPage
    },
    infoResendSms() {
      return this.generateCodePhoneDisable ? this.$t('preRegistration.resendCode') : this.$t('preRegistration.resendSms')
    },
    infoResendEmail() {
      return this.generateCodeEmailDisable ? this.$t('preRegistration.resendCode') : this.$t('preRegistration.resendEmail')
    },
    placeholderMenu() {
      return !this.disableMenu && this.menu.length === 0 ? this.$t('common.empty') : ''
    },
    validPersonalDataAgreement() {
      return !this.personalDataAgreement || this.personalData
    },
    haveConfirm() {
      return (this.emailConfirm || this.phoneConfirm)
    }
  },
  methods: {
    ...mapActions({
      registrationSet: types.APP.registration.set,
      apiKeySet: types.APP.apiKey.set,
      refererSet: types.APP.referer.set
    }),
    inputName() {
      this.$v.name.$touch()
    },
    inputEmail() {
      this.isGenerateCode = false
    },
    focusEmail() {
      this.$v.email.$reset()
    },
    inputPhone() {
      this.isGenerateCode = false
    },
    focusPhone() {
      this.$v.phone.$reset()
    },
    inputCaptcha() {
      this.captchaErrorMessage = null
      this.$v.captcha.$touch()
    },
    inputPersonalDataAgreementValue() {
      this.$v.personalData.$reset()
    },
    inputConfirmEmailCode() {
      this.confirmEmailErrorMessage = null
    },
    inputConfirmPhoneCode() {
      this.confirmPhoneErrorMessage = null
    },
    onChangeLocation(value) {
      this.menuItem = null
      this.day = null
      this.queue = null
      this.times = []
      this.schedules = []
      this.scheduleErrorMessage = null
      this.resetMainFields()
      this.registrator = this.locations.find(location => location.id === value).other
      if (this.registrator) {
        this.$service.getRegistratorMenu(this.apiKey, this.registrator)
          .then(res => {
            this.menu = res
          })
          .catch(err => {
            this.$service._catchError(err)
          })
      } else {
        this.$service._catchError()
      }
    },
    onChangeQueue() {
      if (this.menuItem) {
        this.queue = this.menu.find(value => {
          if (value.group) {
            return false
          }
          return value.id === this.menuItem
        })
      } else {
        this.queue = null
      }
      this.day = null
      this.times = []
      this.schedules = []
      this.scheduleErrorMessage = null
      this.resetMainFields()
    },
    onChangeDay() {
      this.$v.times.$reset()
      this.times = []
      this.schedules = []
      this.scheduleErrorMessage = null
      this.resetMainFields()
      if ((this.email || this.phone) && this.queue.queueId) {
        this.$service.validatePreregistration(this.apiKey, this.normalizePhone(this.phone), this.email, this.queue.queueId, this.normalizeDate(this.day))
          .then(() => this.initPreRegistrationSchedule())
          .catch(err => {
            const data = err.response.data
            this.scheduleError = true
            this.scheduleErrorMessage = data.description
          })
      } else {
        this.initPreRegistrationSchedule()
      }
    },
    initPreRegistrationSchedule() {
      this.$service.getPreRegistrationSchedule(this.location, this.queue.queueId, this.normalizeDate(this.day), this.apiKey)
        .then(res => {
          this.times = []
          this.schedules = res
        })
        .catch(err => {
          this.$service._catchError(err)
        })
    },
    isInvalidPage() {
      if (!this.webForm.screens[this.page]) {
        return false
      }

      let isValid = false
      for (const element of this.webForm.screens[this.page].elements) {
        if (this.$v[element.code]) {
          this.$v[element.code].$touch()
          isValid = isValid || this.$v[element.code].$invalid
        }
      }
      return isValid
    },
    generateCode(email, phone) {
      let normalizePhone
      if (phone) {
        this.generateCodePhoneDisable = true
        normalizePhone = this.normalizePhone(phone)
      }

      if (email) {
        this.generateCodeEmailDisable = true
      }

      if (this.location && this.locations && this.registrator) {
        this.$service.generateConfirmCode(this.registrator, this.apiKey, normalizePhone, email, this.authInfo, this.captcha)
          .catch(err => this.$service._catchError(err))
      }
    },
    resendCode(transport) {
      if (!this.apiKey || !this.registrator || !transport) {
        return
      }
      if (transport === 'phone') {
        this.generateCodePhoneDisable = true
      }
      if (transport === 'email') {
        this.generateCodeEmailDisable = true
      }
      this.$service.resendConfirmCode(this.apiKey, this.registrator, transport, this.authInfo)
        .catch(err => this.$service._catchError(err))
    },
    getMaxLength(validationField) {
      if (validationField && validationField.maxLength) {
        return validationField.$params.maxLength.max
      }
      return undefined
    },
    getNow() {
      return new Date()
    },
    normalizePhone(phone) {
      if (phone && phone !== '') {
        return parsePhoneNumber(phone, 'RU').number
      }
      return null
    },
    normalizeDate(date) {
      if (date !== null && typeof date !== 'undefined') {
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON()
      }
      return null
    },
    normalizeText(text) {
      if (text === null || text === undefined) {
        return null
      }
      if (text.trim() === '') {
        return null
      }
      return text
    },
    resetValidator(field) {
      if (this.$v && this.$v[field]) {
        this.$v[field].$reset()
      }
    },
    resetMainFields() {
      this.resetValidator('location')
      this.resetValidator('menuItem')
      this.resetValidator('day')
      this.resetValidator('times')
    },
    captchaRefresh() {
      if (this.apiKey) {
        this.captchaUrl = `${this.$http.defaults.baseURL}/captcha${this.authInfo}?rand=${Math.random()}&length=${this.captchaLength}`
      }
    },
    captchaCheck() {
      if (this.captcha && this.captcha.trim() !== '') {
        return this.$service.captchaCheck(this.apiKey, this.captcha, this.authInfo)
          .then(() => {
            return true
          })
          .catch(err => {
            const data = err.response.data
            // 4 - код ошибки капчи
            if (data.code === validateError.CAPTCHA) {
              this.captchaErrorMessage = data.description
              this.captcha = ''
              this.captchaRefresh()
              return false
            }
            this.$service._catchError(err)
            return false
          })
      }
      return Promise.resolve(false)
    },
    onThisPage(reqElement) {
      if (this.webForm) {
        for (const element of this.webForm.screens[this.page].elements) {
          if (element.code === reqElement) {
            return true
          }
        }
      }
      return false
    },
    async validateAll() {
      // общая валидация
      if (this.isInvalidPage()) {
        return Promise.resolve(false)
      }

      // капча
      for (const element of this.webForm.screens[this.page].elements) {
        if (element.code === 'captcha') {
          this.captchaValid = await this.captchaCheck()
          if (!this.captchaValid) {
            return Promise.resolve(false)
          }
          break
        }
      }

      // Нужно ли подтверждение показывать на последнем экране. В этом случае сначала происходит ввод телефона/email,
      // а на следующих экранах уже выбор локации.
      if (this.haveConfirm && !this.showConfirmCodesOnLastPage && !this.registrator) {
        this.showConfirmCodesOnLastPage = true
      }

      // генерация кодов
      if (this.showConfirmPage && !this.isGenerateCode) {
        if (this.captchaLength > 0 && !this.captchaValid) {
          return Promise.resolve(false)
        }
        const email = this.lastEmail !== this.email ? this.email : undefined
        const phone = this.lastPhone !== this.phone ? this.phone : undefined
        if (email || phone) {
          this.generateCode(email, phone)
        }

        this.isGenerateCode = true
        this.lastEmail = this.email
        this.lastPhone = this.phone

        return Promise.resolve(false)
      }

      // проверка кодов
      if (this.showConfirmPage && this.isGenerateCode) {
        return this.$service.verifyConfirmCodes({
          registratorId: this.registrator,
          phone: this.phone ? this.normalizePhone(this.phone) : null,
          email: this.email,
          phoneConfirmCode: this.confirmPhone,
          emailConfirmCode: this.confirmEmail
        }, this.apiKey, this.authInfo)
          .then(res => {
            this.registrationSet(res)
            return true
          })
          .catch(err => {
            const data = err.response.data

            // 5 - неверный код SMS
            if (data.code === validateError.SMS) {
              this.confirmPhoneErrorMessage = data.description
              this.confirmPhone = null
              this.disableConfirmPhone = false
              return false
            }
            // 6 - неверный код email
            if (data.code === validateError.EMAIL) {
              this.confirmEmailErrorMessage = data.description
              this.confirmEmail = null
              this.disableConfirmEmail = false
              return false
            }

            this.$service._catchError(err)
          })
      }

      return Promise.resolve(true)
    },
    prevPage() {
      if (this.page > 0) {
        this.page--
      }
    },
    async nextPage() {
      if (!await this.validateAll()) {
        return
      }

      if (this.page < this.maxPage) {
        this.page++
      }

      window.parent.postMessage({ type: 'startRegistration' }, '*')
    },
    async save() {
      if (!await this.validateAll()) {
        return
      }

      if (this.page === this.maxPage && this.page === 1 && this.captchaLength > 0) {
        const validCaptcha = await this.captchaCheck()
        if (!validCaptcha) {
          return
        }
      }

      this.confirmPhoneErrorMessage = null
      this.confirmEmailErrorMessage = null
      this.disableConfirmEmail = true
      this.disableConfirmPhone = true

      const preRegistrationIds = this.times.map(value => value.preRegistrationProfileItemId)
      this.$service.save({
        locationId: this.location,
        queueId: this.queue.queueId,
        day: this.normalizeDate(this.day),
        registratorId: this.registrator,
        preRegistrationIds,
        name: this.name,
        email: this.email,
        phone: this.phone ? this.normalizePhone(this.phone) : null,
        comment: this.normalizeText(this.comment),
        phoneConfirmCode: this.confirmPhone,
        emailConfirmCode: this.confirmEmail
      }, this.apiKey, this.authInfo)
        .then(res => {
          this.registrationSet(res)
          this.$pageManager.showSuccessRegistration()

          window.parent.postMessage({ type: 'finishRegistration' }, '*')
        })
        .catch(err => {
          const data = err.response.data
          // 5 - неверный код SMS
          if (data.code === validateError.SMS) {
            this.confirmPhoneErrorMessage = data.description
            this.confirmPhone = null
            this.disableConfirmPhone = false
            return
          }
          // 6 - неверный код email
          if (data.code === validateError.EMAIL) {
            this.confirmEmailErrorMessage = data.description
            this.confirmEmail = null
            this.disableConfirmEmail = false
            return
          }
          // 7 - расписание занято
          if (data.code === validateError.SCHEDULE) {
            this.$v.times.$reset()
            this.scheduleError = true
            this.scheduleErrorMessage = data.description
            this.$service._showWarning(`${data.description}. ${this.$t('preRegistration.scheduleNotHasPlace')}`)
            this.$service.getPreRegistrationSchedule(this.location, this.queue.queueId, this.normalizeDate(this.day), this.apiKey)
              .then(res => {
                for (const screen of this.webForm.screens) {
                  for (const element of screen.elements) {
                    if (element.code === 'times') {
                      this.page = screen.step
                    }
                  }
                }

                this.times = []
                this.schedules = res
              })
              .catch(err => {
                this.$service._catchError(err)
              })
            return
          }
          this.$service._catchError(err)
        })
    }
  },
  beforeMount() {
    const apiKey = this.$route.query.key
    const referer = document.referrer
    if (!apiKey) {
      this.$service._catchError(this.$t('error.apiKeyNotFound'))
      return
    }
    this.refererSet(referer)

    this.apiKey = apiKey
    this.apiKeySet(this.apiKey)

    this.$service.getSetup(this.apiKey)
      .then(res => {
        this.locations = res.locations
        this.webDomain = res.webDomain
        this.generateCodeEmailDisableTime = res.disableGenerateEmailCode
        this.generateCodePhoneDisableTime = res.disableGeneratePhoneCode
        this.authInfo = res.authInfo

        this.webForm = res.webForm
        this.maxPage = this.webForm.screens.length - 1

        for (const screen of this.webForm.screens) {
          for (const element of screen.elements) {
            if (element.code === 'captcha' && element.length) {
              this.captchaLength = element.length
            }

            if (element.code === 'email' && element.confirmable) {
              this.emailConfirm = true
            }

            if (element.code === 'phone' && element.confirmable) {
              this.phoneConfirm = true
            }

            if (element.code === 'personalData') {
              this.personalDataAgreement = true
            }
          }
        }

        if (this.locations.length === 0) {
          this.$service._showWarning(this.$t('preRegistration.registratorNotFound'))
        }

        this.captchaRefresh()
      })
      .catch(err => {
        this.$service._catchError(err)
      })
  }
}

const validateError = {
  CAPTCHA: 4,
  SMS: 5,
  EMAIL: 6,
  SCHEDULE: 7
}
